import React from 'react';
import UniversityAdminConsole from '../../components/UniversityAdmin/UniversityAdminConsole';

const UniversityAdminConsolePage = () => {
  return <UniversityAdminConsole />;
};

export default UniversityAdminConsolePage;
